import React from 'react';

export default function SpeedometerSVG() {
  return (
    <svg
      height="1em"
      viewBox="0 0 151 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M119.058 55.3185C125.005 63.8224 128.491 74.1719 128.491 85.3417V85.6152C128.491 89.1972 131.403 92.1093 134.985 92.1093C138.567 92.1093 141.479 89.1972 141.479 85.6152V85.3417C141.479 49.1799 112.167 19.8813 76.0189 19.8813C39.8708 19.8813 10.5448 49.1936 10.5448 85.3417V85.6152C10.5448 89.1972 13.4569 92.1093 17.0389 92.1093C20.6209 92.1093 23.533 89.1972 23.533 85.6152V85.3417C23.533 56.3576 47.0211 32.8695 76.0053 32.8695C88.0911 32.8695 99.2063 36.9573 108.079 43.8069"
        stroke="currentColor"
        strokeWidth="2.73435"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.22 43.301L74.9936 81.7324C74.0229 82.5664 73.3803 83.7831 73.3803 85.164C73.3803 87.6659 75.4037 89.6894 77.9057 89.6894C79.3275 89.6894 80.5717 89.0194 81.4056 87.994L120.22 43.301Z"
        fill="currentColor"
      />
      <path
        d="M101.913 0.904877L108.421 7.79545"
        stroke="currentColor"
        strokeWidth="1.36718"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M108.421 0.904877L101.913 7.79545"
        stroke="currentColor"
        strokeWidth="1.36718"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.6031 58.9826L57.1109 65.8731"
        stroke="currentColor"
        strokeWidth="1.36718"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.1109 58.9826L50.6031 65.8731"
        stroke="currentColor"
        strokeWidth="1.36718"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M103.267 85.287H110.677"
        stroke="currentColor"
        strokeWidth="1.36718"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7126 10.3931H44.1227"
        stroke="currentColor"
        strokeWidth="1.36718"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M143.462 46.3225C145.523 46.3225 147.194 44.6514 147.194 42.5901C147.194 40.5288 145.523 38.8577 143.462 38.8577C141.4 38.8577 139.729 40.5288 139.729 42.5901C139.729 44.6514 141.4 46.3225 143.462 46.3225Z"
        stroke="currentColor"
        strokeWidth="1.36718"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.666 48.633C5.94207 48.633 6.97653 47.5986 6.97653 46.3225C6.97653 45.0464 5.94207 44.012 4.666 44.012C3.38993 44.012 2.35547 45.0464 2.35547 46.3225C2.35547 47.5986 3.38993 48.633 4.666 48.633Z"
        stroke="currentColor"
        strokeWidth="1.36718"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.60352 94.2557H149.669"
        stroke="currentColor"
        strokeWidth="1.36718"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="2.73 2.73"
      />
    </svg>
  );
}
